import { configure } from '@creditas/event-track';

const eventTrackService = configure({
  application: 'b2b-authentication-app',
  bu: 'PA',
  environment: process.env.APP_ENV,
});

export { eventTrackService };
